import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";

import App from "./App";
import "../node_modules/dstill/dist/output.css";
import "./tailwind-output.css";
import { GlobalContextProvider } from "./context/Global";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<GlobalContextProvider>
				<I18nextProvider i18n={i18n}>
					<App />
				</I18nextProvider>
			</GlobalContextProvider>
		</BrowserRouter>
	</React.StrictMode>
);
